import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Panel } from '../../../../../common/panel'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { selectCompareIndustry, selectDefaultIndustry } from '../../store/slice'
import { Content } from './Content'
import { selectIds } from './store/slice'
import { downloadBusinessGrowth, postBusinessGrowth } from './store/thunk'

export const BusinessGrowth = ({ settingsFS }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const { currency, unitName, multiplier } = useFormatCurrency(
    SCREEN.INDUSTRY_ANALYSIS,
  )
  const ids = useSelector(selectIds)
  const vsicDefault = useSelector(selectDefaultIndustry)
  const vsicCompare = useSelector(selectCompareIndustry)
  const locale = useSelector((state) => state.i18n.locale)

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(
      postBusinessGrowth({
        organizationId,
        vsicDefault,
        vsicCompare,
        ...settingsFS,
      }),
    )
  }, [vsicDefault, vsicCompare, locale])

  return (
    <Panel
      isI18n
      height={500}
      label="companyAnalysis.industryAnalysis.BUSINESS_GROWTH"
      downloadCsv={{
        disabled: !ids.length,
        downloadFunc: () =>
          downloadBusinessGrowth({
            organizationId,
            vsicDefault,
            vsicCompare,
            currency,
            currencyUnit: {
              multiplier,
              value: unitName,
            },
            ...settingsFS,
          }),
      }}
    >
      <Content />
    </Panel>
  )
}
